'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { PATH_URL } from '@/constants/path-constants';
import { useManageTeamNavItems } from './useManageTeamNavItems';

/**
 * Hook to enforce access control on manage-team pages.
 * Redirects to team-profile (members tab) if user doesn't have access to the current route.
 * Uses useManageTeamNavItems as the source of truth for access permissions.
 */
export function useManageTeamPageAccess(currentRoute: string): {
  hasAccess: boolean;
  isLoading: boolean;
} {
  const router = useRouter();
  const { hasAccessToRoute, isLoading } = useManageTeamNavItems();

  const hasAccess = hasAccessToRoute(currentRoute);

  // Redirect to team-profile if unauthorized
  useEffect(() => {
    if (!isLoading && !hasAccess && currentRoute !== PATH_URL.TEAM_PROFILE) {
      router.replace(PATH_URL.TEAM_PROFILE);
    }
  }, [isLoading, hasAccess, currentRoute, router]);

  return {
    hasAccess,
    isLoading,
  };
}
